import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../components/layout/Layout";
import {
  apkDelete,
  apkFlagOff,
  apkUpload,
  fetchApk,
} from "../../Redux/Actions/Apk";
// import { AiFillAndroid } from "react-icons/ai";
import { FaRegTrashAlt } from "react-icons/fa";
import { AiFillAndroid } from "react-icons/ai";
import toast from "react-hot-toast";
import Loader from "../../components/loader/Loader";
import "./apkmanage.css";
import { api } from "../../api/api";
import { CopyAllOutlined, UploadFile } from "@mui/icons-material";
// import Circularbar from "../../components/circularbar/Circularbar";
function ApkManage({ user }) {
  const dispatch = useDispatch();
  const {
    apk,
    apkLoading,
    apkLoaded,
    isAvailable,
    isAdded,
    identity,
    isAdding,
  } = useSelector((state) => state.Apk);
  const inputRef = useRef(null);
  const [percent, setPercent] = useState(0);
  const [status, setStatus] = useState("");
  const [browseApk, setBrowseApk] = useState("");
  const [openSaveDialog, setOpenDialogSave] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openFileUploader, setOpenFileUploader] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  useEffect(() => {
    dispatch(fetchApk());
  }, []);
  useEffect(() => {
    if (isAvailable) {
      setOpenFileUploader(true);
      setPercent(0);
      toast.success("This Apk already available");
      dispatch(apkFlagOff());
    }
    if (isAdded) {
      setOpenFileUploader(false);
      setPercent(0);
      toast.success("Apk saved successfully");
      dispatch(apkFlagOff());
    }
    if (identity) {
      toast.success("This apk not valid.");
      dispatch(apkFlagOff());
    }
  }, [isAvailable, isAdded, identity]);
  const handleUpload = (e) => {
    //  console.log(e)
    // if(e.target.files.length!==0){
    setStatus("idle");
    // console.log(e);
    setBrowseApk(e);
    // setOpenDialogSave(true);
    // }
  };
  // console.log('starting server')
  const handleSave = async () => {
    setOpenDialogSave(false);
    // console.log(browseApk)
    const form = new FormData();
    form.append("apk", browseApk);
    setBrowseApk("");
    const apk = await api.post(`/apk/apkfile`, form, {
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        console.log("percent->", percentCompleted);
        setPercent(percentCompleted);
      },
    });
    dispatch(apkUpload(apk));
    if (inputRef.current) {
      inputRef.current = "";
    }
  };
  const handleCancel = () => {
    setBrowseApk("");
    setOpenDialogSave(false);
    if (inputRef.current) {
      inputRef.current = "";
    }
  };
  const handleDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setDeleteId(id);
  };
  const handleDelete = () => {
    setOpenDeleteDialog(false);
    dispatch(apkDelete(deleteId));
  };
  return (
    <>
      <Layout title={"Apk Management"} user={user} playlistAddBtn={false}>
        <Container maxWidth={"lg"} className="apk-page-shell" sx={{ px: { xs: 1, sm: 2 } }}>
          <Grid container mt={2} sx={{ backgroundColor: "#ffffff" }}>
            <Box
              sx={{
                height: "50vh",
                width: "100%",
                border: "1px solid white",
                borderRadius: "10px",
                // position:'relative'
              }}
            >
              {isAdding && (
                <>
                  <Box
                    sx={{
                      height: "100vh",
                      width: "100vw",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      zIndex: 10000,
                      background: "rgba(0,0,0,0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Loader />
                  </Box>
                </>
              )}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TableContainer className="apk-table-wrap">
                  <Table className="apk-data-table" size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={6}>
                          <label
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            Browse{" "}
                            <AiFillAndroid
                              style={{
                                fontSize: "20px",
                                color: "var(--primary-color)",
                                cursor: "pointer",
                              }}
                              onClick={() => setOpenFileUploader(true)}
                            // onClick={() =>
                            //   document.getElementById("apk-brow").click()
                            // }
                            />{" "}
                            Apk File
                          </label>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="center">Sr.#</TableCell>
                        <TableCell align="center">Upload Date</TableCell>
                        <TableCell align="center">Version Name</TableCell>
                        <TableCell align="center">Version Code</TableCell>
                        <TableCell align="center">Package</TableCell>
                        <TableCell align={"center"}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {apk.map((a, index) => (
                        <>
                          <TableRow>
                            <TableCell align={"center"}>{++index}</TableCell>
                            <TableCell align={"center"}>
                              {new Date(a?.createdAt).toLocaleString()}
                            </TableCell>
                            <TableCell align={"center"}>
                              {a?.versionName}
                            </TableCell>
                            <TableCell align={"center"}>
                              {a?.versionCode}
                            </TableCell>
                            <TableCell align={"center"}>{a?.package}</TableCell>
                            <TableCell align={"center"}>
                              <Box className="apk-table-actions" sx={{
                                display:'flex',
                                justifyContent:'center',
                                alignItems:'center',
                                gap:'10px'
                              }}>
                              <CopyAllOutlined
                                style={{
                                  fontSize: "17px",
                                  color: "red",
                                  cursor: "pointer",
                                }}
                                onClick={
                                  async () => {
                                    if (navigator && navigator.clipboard != undefined)
                                      await navigator.clipboard.writeText(a?.url)
                                    toast.success(`Copied the link ${a?.url}`)
                                  }
                                }
                              />
                              <FaRegTrashAlt
                                style={{
                                  fontSize: "17px",
                                  color: "red",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleDeleteDialog(a?._id)}
                              />
                              </Box>
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Layout>

      <Dialog
        maxWidth={"md"}
        sx={
          {
            // maxWidth: '20vw',
            // height: '30vh'
            // zIndex: "100000000",
          }
        }
        open={openFileUploader}
        onClose={() => setOpenFileUploader(false)}
      >
        <DialogTitle
          sx={{
            fontWeight: "700",
            fontSize: "18px",
            borderBottom: "2px solid var(--primary-color)",
            mb: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          Upload Apk
        </DialogTitle>
        <DialogContent>
          <Box className="h-[30vh] w-[30vw] flex flex-col gap-5 justify-center items-center border-none border-black">
            <input
              type="file"
              ref={inputRef}
              onChange={(e) => handleUpload(e.target.files[0])}
              hidden
              id={"apk-brow"}
            />
            {browseApk === "" &&
              <label
                htmlFor="apk-brow"
                className="h-[50px] w-[150px] py-10 flex flex-col justify-center items-center border-dotted border-[1.5px] border-black rounded-md"
              >
                <UploadFile />
                Upload Apk
              </label>
            } {browseApk !== '' &&
              <div className="h-[50px] w-[350px] py-10 flex justify-center items-center gap-2 border-dotted border-[1.5px] border-black rounded-md">

                <span>{browseApk.name.substr(0, 30)}</span>{" "}
                <div className="flex flex-col gap-2">
                  <button
                    onClick={handleSave}
                    className="h-[30px] w-[70px] border border-black rounded-md"
                  >
                    Upload
                  </button>{" "}
                  <button
                    onClick={handleCancel}
                    className="h-[30px] w-[70px] border border-black rounded-md"
                  >
                    Cancel
                  </button>
                </div>

                  
              </div>
            }
            <div className="h-[20px] w-[350px] border-none border-black rounded-lg bg-gray-200 shadow-lg">
              <div
                style={{ width: `${percent}%` }}
                className={`h-[20px] bg-[#008080] rounded-lg`}
              ></div>
            </div>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog maxWidth={"lg"} open={openSaveDialog} onClose={handleCancel}>
        <DialogTitle
          sx={{
            fontWeight: "700",
            fontSize: "18px",
            borderBottom: "2px solid #551FFF",
            mb: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          Save
          {/* <AiFillAndroid style={{fontSize:'30px',color:'#1977fa'}}/> Confirmation */}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              gap: "2px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "#92959E" }}>
              Do you want to save?
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: "5px",
              }}
            >
              <Button
                variant={"outlined"}
                onClick={handleCancel}
                sx={{ width: "100px" }}
              >
                Cancel
              </Button>
              <Button
                variant={"contained"}
                onClick={handleSave}
                sx={{ width: "100px" }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        maxWidth={"lg"}
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(true)}
      >
        <DialogTitle
          sx={{
            fontWeight: "700",
            fontSize: "18px",
            borderBottom: "2px solid #551FFF",
            mb: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          Delete
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              gap: "2px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: "#92959E",
              }}
            >
              Are you sure to delete this file?
            </Typography>
            <Box
              sx={{
                display: "flex",
                mt: 5,
                gap: "5px",
              }}
            >
              <Button
                variant={"outlined"}
                onClick={() => setOpenDeleteDialog(false)}
                sx={{ width: "100px" }}
              >
                No
              </Button>
              <Button
                variant={"contained"}
                onClick={handleDelete}
                sx={{ width: "100px" }}
              >
                Yes
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ApkManage;
